import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ctr"]

  onComingFromChange(event) {
    this.ctrTarget.required = event.currentTarget.value === 'quantum'
  }
}